export default __webpack_public_path__ + "static/media/logout.2215cf55.svg";